var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notice-box" },
    [
      _c(
        "el-tabs",
        { attrs: { type: "card" } },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "公告" } },
            [
              _vm.notices.length
                ? _vm._l(_vm.notices, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "notice-box__item",
                        on: {
                          click: function($event) {
                            return _vm.open(item, 0)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "notice-box__item__title" }, [
                          _vm._v(_vm._s(item.Title))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "notice-box__item__content" },
                          [_vm._v(_vm._s(_vm.noticeContent(item.Content)))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "notice-box__item__time" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm._f("dayFormat")(
                                  item.UpdateTime,
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "notice-box__item__action",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.open(item, 0)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "el-icon-view" }),
                              _vm._v(_vm._s(item.DetailCount))
                            ]
                          )
                        ])
                      ]
                    )
                  })
                : _c("div", { staticClass: "notice-box__empty" }, [
                    _vm._v("暂无公告信息")
                  ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "notice-box__footer",
                  on: { click: _vm.commonNotice }
                },
                [_vm._v("查看更多 >>")]
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "重要通知" } },
            [
              _vm.pNotices.length
                ? _vm._l(_vm.pNotices, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: "p_" + index,
                        staticClass: "notice-box__iteration",
                        on: {
                          click: function($event) {
                            return _vm.open(item, 1)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "notice-box__iteration__title" },
                          [_vm._v(_vm._s(item.Title))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "notice-box__iteration__time" },
                          [
                            _c("div", [
                              _vm._v(_vm._s(_vm._f("fromNow")(item.UpdateTime)))
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "notice-box__item__action",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.open(item, 1)
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "el-icon-view" }),
                                _vm._v(_vm._s(item.DetailCount))
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  })
                : _c("div", { staticClass: "notice-box__empty" }, [
                    _vm._v("暂无更新日志信息")
                  ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "notice-box__footer",
                  on: { click: _vm.significanceNotice }
                },
                [_vm._v("查看更多 >>")]
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf51ddf0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf51ddf0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notice.vue
// module id = null
// module chunks = 